import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const AttachmentIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8 23a7 7 0 0 1-7-7 7 7 0 0 1 2-5l8.6-8.5a5 5 0 1 1 7 7l-8.5 8.6a3.1 3.1 0 0 1-4.2 0 3 3 0 0 1 0-4.2l8.5-8.5a1 1 0 1 1 1.4 1.4l-8.5 8.5a1 1 0 0 0-.3.7c0 .3.1.5.3.7.4.4 1 .4 1.4 0l8.6-8.6a3 3 0 0 0 0-4.2 3 3 0 0 0-4.3 0l-8.5 8.6a5 5 0 1 0 7 7l9.2-9.2a1 1 0 1 1 1.4 1.4L13 21a7 7 0 0 1-5 2Z" />
    </Icon>
  )
);
export default AttachmentIcon;
